<div #rangeSliderElement id="rangeslider-wrapper-{{ identifier }}">
  <label for="rangeslider-{{ identifier }}">Gewählter Umkreis</label>
  <div class="now-range-slider">
    <output class="now-badge" aria-hidden="true" for="rangeslider-{{ identifier }}"></output>
    <input
      type="range"
      autocomplete="off"
      name="range-slider-{{ identifier }}"
      id="rangeslider-{{ identifier }}"
      min="0"
      [max]="range.length - 1"
      [attr.value]="value"
      [attr.aria-label]="label"
      step="1"
      (change)="changed.emit($event)"
    />
    <datalist id="datalist-{{ identifier }}" aria-hidden="true">
      @for (option of range; track option; let index = $index) {
        <option [value]="index" [label]="index === 0 || index === 5 ? labelFunction(option) : ''">
          {{ labelFunction(option) }}
        </option>
      }
    </datalist>
  </div>
</div>
